import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Check if Nunito Sans font is loaded
document.fonts.ready.then(() => {
  const isLoaded = document.fonts.check('12px "Nunito Sans"');
  console.log('Nunito Sans font loaded:', isLoaded);
  console.log('All loaded fonts:', [...document.fonts].map(f => f.family));
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
